import { useLiveQuery } from 'dexie-react-hooks';
import { useEffect, useState } from 'react';
import { useWorkspace } from '@/app/providers/workspace-provider';
import type { Attachment, AttachmentOwnerType, Uuid } from '@/data/db';

export function useAttachmentsFor(
  ownerType: AttachmentOwnerType,
  ownerId: Uuid | null,
): Attachment[] | undefined {
  const { db } = useWorkspace();
  return useLiveQuery(async () => {
    if (!ownerId) return [];
    return db.attachments.where('[ownerType+ownerId]').equals([ownerType, ownerId]).toArray();
  }, [db, ownerType, ownerId]);
}

export function useAllAttachments(): Attachment[] | undefined {
  const { db } = useWorkspace();
  return useLiveQuery(() => db.attachments.toArray(), [db]);
}

export function useAttachmentCount(): number | undefined {
  const { db } = useWorkspace();
  return useLiveQuery(() => db.attachments.count(), [db]);
}

/**
 * 把 Blob 轉成暫時的 URL，卸載時釋放。
 * 只有開啟檢視器時才讀大圖（spec 16.2）。
 */
export function useBlobUrl(blob: Blob | null | undefined): string | null {
  const [url, setUrl] = useState<string | null>(null);

  /* oxlint-disable react/set-state-in-effect -- 建立與釋放 object URL 本來就是同步外部資源，正是 effect 的用途 */
  useEffect(() => {
    if (!blob) {
      setUrl(null);
      return;
    }
    const objectUrl = URL.createObjectURL(blob);
    setUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [blob]);
  /* oxlint-enable react/set-state-in-effect */

  return url;
}
